import { createSlice } from '@reduxjs/toolkit';
import type { WorkspaceCredential } from '../../types/workspaceCredentials';
import {
  createWorkspaceCredential,
  deleteWorkspaceCredential,
  fetchWorkspaceCredentials,
  updateWorkspaceCredential,
} from './actions';

interface WorkspaceCredentialsState {
  items: WorkspaceCredential[];
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: WorkspaceCredentialsState = {
  items: [],
  loading: false,
  saving: false,
  error: null,
};

const workspaceCredentialsSlice = createSlice({
  name: 'workspaceCredentials',
  initialState,
  reducers: {
    clearWorkspaceCredentials: (state) => {
      state.items = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkspaceCredentials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkspaceCredentials.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchWorkspaceCredentials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro ao carregar credenciais';
      })
      .addCase(createWorkspaceCredential.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(createWorkspaceCredential.fulfilled, (state, action) => {
        state.saving = false;
        state.items = [action.payload, ...state.items.filter((c) => c.id !== action.payload.id)];
      })
      .addCase(createWorkspaceCredential.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload ?? 'Erro ao criar credencial';
      })
      .addCase(updateWorkspaceCredential.fulfilled, (state, action) => {
        state.items = state.items.map((c) => (c.id === action.payload.id ? action.payload : c));
      })
      .addCase(deleteWorkspaceCredential.fulfilled, (state, action) => {
        state.items = state.items.filter((c) => c.id !== action.payload);
      });
  },
});

export const { clearWorkspaceCredentials } = workspaceCredentialsSlice.actions;
export const workspaceCredentialsReducer = workspaceCredentialsSlice.reducer;
